import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateTemplate } from "configs/utils/Excel";
import { DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss } from "constants/DateConstant";
import dayjs from 'dayjs';

export const getAllSkalaPenilaian = createAsyncThunk("skalaPenilaian/getAllSkalaPenilaian", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/skala/nilai');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getSkalaPenilaianById = createAsyncThunk("skalaPenilaian/getSkalaPenilaianById", 
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/skala/nilai/${id}`);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const deleteSkalaPenilaian = createAsyncThunk("skalaPenilaian/deleteSkalaPenilaian", 
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			await jwtAuthAxios.delete(`v1/skala/nilai/${id}`);
			return id;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const addSkalaPenilaian = createAsyncThunk("skalaPenilaian/addSkalaPenilaian",
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.post('v1/skala/nilai', payload);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const updateSkalaPenilaian = createAsyncThunk("skalaPenilaian/updateSkalaPenilaian", 
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.put('v1/skala/nilai', payload);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const downloadTemplateExcel = createAsyncThunk("skalaPenilaian/downloadTemplateExcel",
	async (payload, { rejectWithValue }) => {
		try {
			const workbook = await generateTemplate(payload);

			// Save to blob
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
			});
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = 'skala_penilaian_data.xlsx';

      // Trigger a click on the link to initiate the download
      link.click();

      // Cleanup
      URL.revokeObjectURL(url);
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

const skalaPenilaian = {
	nama_program_studi: '',
	nilai_huruf: '',
	nilai_indeks: '',
	bobot_minimum: '',
	bobot_maksimum: '',
	tanggal_mulai_efektif: dayjs('1980-01-01', DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss),
	tanggal_akhir_efektif: dayjs('1980-01-01', DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss),
};

const initialState = {
	allSkalaPenilaian: [],
	single: { ...skalaPenilaian },
	status: {
		loading: false
	}
}

const skalaPenilaianSlice = createSlice({
	name: "skalaPenilaian",
	initialState,
	reducers: {
    onRefreshForm: (state) => {
			state.single = initialState.single
      state.status = initialState.status;
    },
    onRefreshStatus: (state) => {
      state.status = initialState.status;
    },
    onChangeData: (state, action) => ({
      ...state, 
      ...action.payload
    }),
	},
	extraReducers: {
		[getAllSkalaPenilaian.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getAllSkalaPenilaian.fulfilled]: (state, action) => {
			state.allSkalaPenilaian = action.payload;
			state.status.loading = false;
		},
		[getAllSkalaPenilaian.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getSkalaPenilaianById.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getSkalaPenilaianById.fulfilled]: (state, action) => {
			state.single = action.payload;
			state.status.loading = false;
		},
		[getSkalaPenilaianById.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[addSkalaPenilaian.pending]: (state, action) => {
			state.status.loading = true;
		},
		[addSkalaPenilaian.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[addSkalaPenilaian.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[deleteSkalaPenilaian.pending]: (state, action) => {
			state.status.loading = true;
		},
		[deleteSkalaPenilaian.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[deleteSkalaPenilaian.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[updateSkalaPenilaian.pending]: (state, action) => {
			state.status.loading = true;
		},
		[updateSkalaPenilaian.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[updateSkalaPenilaian.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[downloadTemplateExcel.pending]: (state, action) => {
			state.status.loading = true;
		},
		[downloadTemplateExcel.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[downloadTemplateExcel.rejected]: (state, action) => {
			state.status.loading = false;
		},
	}
})

export const { 
	onRefreshForm,
	onRefreshStatus,
	onChangeData,
} = skalaPenilaianSlice.actions;

export const selectSkalaPenilaian = (state) => state.skalaPenilaian;

export default skalaPenilaianSlice.reducer;